<template>
  <div class="vue-sessionstack"></div>
</template>

<script>
  import CustomerHelper from "../../helpers/CustomerHelper";
  import config from '../../../config';
  import CookieHelper from "../../helpers/CookieHelper";

  export default {
    name: `SessionStack`,
    async mounted() {
      if(CookieHelper.checkIfExternalCookieIsAccepted(`sessionstack`, this.initSessionStack) && CustomerHelper.getLoggedInState()) {
        this.initSessionStack();
      }
    },
    methods: {
      getProjectIdForEnvironment() {
        return config.sessionStack.projectId;
      },
      async initSessionStack() {
        /* eslint-disable */
        ((a, b) => {
          const c = window; c.SessionStackKey = a, c[a] = c[a] || {
            q: [],
            t: b,
          }; for(let d = [`start`, `stop`, `identify`, `getSessionId`, `log`, `setOnDataCallback`], e = 0; e < d.length; e++) {
            (b => {
              c[a][b] = c[a][b] || function() {
                c[a].q.push([b].concat([].slice.call(arguments, 0)));
              };
            })(d[e]);
          } const f = document.createElement(`script`); f.async = 1, f.crossOrigin = `anonymous`,
            f.src = `https://cdn.sessionstack.com/sessionstack.js`; const g = document.getElementsByTagName(`script`)[0];
          g.parentNode.insertBefore(f, g);
        })(`SessionStack`, this.getProjectIdForEnvironment());
        const personalInfo = await CustomerHelper.getPersonalInfo();
        let userId = -1;
        if(personalInfo && personalInfo.account && personalInfo.account.customerNumber) {
          userId = personalInfo.account.customerNumber;
        }
        SessionStack.identify({
          userId,
        });
        /* eslint-enable */
      },
    },
  };
</script>

<style lang="less" scoped>
  .vue-sessionstack {
    display: none;
  }
</style>
